export default __webpack_public_path__ + "873ff73c6a99febea33b83be78fb42e0.png";